import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { UniPaymentDepositAmountApi } from '../../../../../api/request/wallet/deposit.js';
import { useResponsive } from '../../../../../hooks/useResponsive.js';

const UniPayment = ({ amount, paymentMethod, accounts, resetAll, loginTerminalId, validateAmount }) => {
    const { isMobile } = useResponsive();
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isDepositLoading, setIsDepositLoading] = useState(false);

    const handleSubmit = async () => {
        setIsDepositLoading(true);
        try {
            if (validateAmount) {
                toast.error(validateAmount);
                return;
            }
            if (!amount) {
                toast.error('Please enter deposit amount');
                return;
            }
            const isWallet = loginTerminalId === 'wallet';
            const deposiParams = {
                paymentGatwayId: paymentMethod?.id,
                amount: Number(amount),
                userId: userDetails?.id,
                loginTerminalId: isWallet ? 0 : loginTerminalId,
            };
            const { data } = await UniPaymentDepositAmountApi(deposiParams);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                resetAll();
                window.location.href = data?.data?.invoice_url;
            }
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                'Something went wrong while processing your request.';
            toast.error(message);
        } finally {
            setIsDepositLoading(false);
        }
    };

    return (
        <div>
            <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                <Form.Item
                    name='conditions'
                    valuePropName="checked"
                    rules={[{
                        validator: (_, value) =>
                            value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.'))
                    }]}
                >
                    <Checkbox className='mt-4'>
                        Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                    </Checkbox>
                </Form.Item>

                <LoadableButton
                    className={`text-sm text-white font-semibold rounded-lg px-12 uppercase themeHover duration-500 ${isMobile ? 'bg-primary py-3 w-full' : 'bg-primary py-2'}`}
                    type="submit"
                    lable='Submit'
                    isLoading={isDepositLoading}
                    loadingLable='Adding request...'
                />
            </Form>
        </div>
    )
}

export default UniPayment;
